import { ICover } from '../cover.interface';

interface DiscountDetails {
  discountMode: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  AdditinalOperational_Discount: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  AdditinalOperational_DiscountIsSum: boolean;
  OperationalDiscountPct: number;
  MaxOperationalDiscountSum: number;
  BasePricePlanCurrencyAfterDiscount: number;
  BasePriceBillingCurrencyAfterDiscount: number;
  DiscountSum: number;
  MaxDiscountSum: number;
  DiscountPct: number;
  DiscountOneTime: boolean;
}

export interface MakeQuoteResponse {
  makeQuoteStatus: number;
  leadID: string;
  quoteID: string;
  policyGroupID: number;
  pricePlanCurrency: number;
  planCurrencyISO: string;
  priceBillingCurrency: number;
  billingCurrencyISO: string;
  billingCurrencyRate: number;
  policyName: string;
  policyNameLocal: string;
  days: number;
  participants: MakeQuoteParticipant[];
  exceptionMessage?: string;
  discountDetails: DiscountDetails | null;
  maxNumberOfPayments: number;
  policyDisplayName: string;
}
export interface MakeQuoteParticipant {
  uwResult: number;
  participantNum: number;
  customerID: string;
  leadDataID: string;
  personalNumId: string;
  covers: ICover[];
  purchasedPCBefore: boolean;
}

export enum UWresultStatus {
  Success = 0,
  ErrorAutoRider = 1,
  SPEC = 2,
  AutoRider = 3,
  NoSale = 4,
  AutoRiderFree = 5
}
